/* eslint-disable @next/next/no-img-element */
import { useState, useRef, useEffect } from "react";
import ContentComponent from 'components/tao-bai-viet/noi-dung/content/contentComponent';
import ImageComponent from 'components/tao-bai-viet/noi-dung/image/imageListComponent';
import isEmpty from 'lodash/isEmpty';

export default function EditorComponent({ setContentParent, thumbnail_file_id = null, setState = null, isSingleEditor = false, noNeedImage = false, oldContent =null }) {
    const [count, setCount] = useState(0);
    const [listEditor, setListEditor] = useState([{
        id: count,
        content: '',
        image: []
    }]);

    const [odContent, setOdContent] = useState(oldContent || []);

    useEffect(() => {
        if ( isEmpty(oldContent) ) return;
        setOdContent(oldContent);
        setListEditor(oldContent.map((x, index) => ({
            id: index,
            content: x.content,
            image: x.image || []
        })));
    }, [oldContent]);

    useEffect(() => {
        setContentParent(listEditor);
    }, [listEditor]);

    useEffect(() => {
        if (isEmpty(listEditor) || isEmpty(listEditor[listEditor.length - 1].image)) return;
        setListEditor(listEditor.concat({
            id: count,
            content: '',
            image: []
        }));
    }, [count]);

    const onUploadImage = (id, listImage) => {
        console.log("onUploadImage");
        if(!ready){
            return;
        }
        const cloneListEditor = [...listEditor];
        const thisEditor = cloneListEditor.find(item => item.id == id);
        thisEditor.image = listImage;

        setListEditor(cloneListEditor);
        if (!isSingleEditor && !isEmpty(listEditor[listEditor.length - 1].image)) setCount(count + 1);
    };

    const onChangeContent = (id, content) => {
        console.log("onChangeContent");
        if(!ready){
            return;
        }
        const cloneListEditor = [...listEditor];
        const thisEditor = cloneListEditor.find(item => item.id == id);
        thisEditor.content = content;

        setListEditor(cloneListEditor);
    };
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => setReady(true), 5000); // delay 2s
        return () => clearTimeout(timer); // cleanup khi unmount
    }, []);

    return (
        <div className="demo-dfree" style={{ display: ready?'block':'none' }}>
            <div className="dfree-body">
                {listEditor.map((item, index) => {
                    let contentValue = odContent?.[index]?.content ?? '<p data-reactroot="" data-reactroot=""></p>';
                    if(contentValue === "" || contentValue == null){
                        contentValue = '<p data-reactroot="" data-reactroot=""></p>';
                    }
                    return (
                        <div key={item.id}>
                            <ContentComponent
                                content={contentValue}
                                editorId={item.id}
                                onChangeContent={onChangeContent}
                            />
                            {!noNeedImage && (
                                <ImageComponent
                                    oldImage={item.image}
                                    thumbnail_file_id={thumbnail_file_id}
                                    setThumbnail={setState}
                                    editorId={item.id}
                                    onUploadImage={onUploadImage}
                                    isSingleEditor={isSingleEditor}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
